import { PageResponse } from '@/core/typings/globals';
import { Module } from 'vuex';
import api from '@/core/api/modules/pages';
import * as types from '../mutation-types';

interface State {
  page?: PageResponse;
}

const initialState: State = {
  page: undefined,
};

const pageModule: Module<State, any> = {
  namespaced: true,
  state: initialState,
  getters: {
    page: state => state.page,
    pageColors: state => Object.values(state.page?.css_variables),
    isPublished: state => state.page?.status === 'published',
  },
  actions: {
    async getPages(_, { status, q, page }) {
      return await api.getPages(page, status, q);
    },
    async loadPage({ commit }, id) {
      commit(types.SET_PAGE, null);
      const page = await api.getPage(id);
      commit(types.SET_PAGE, page);
      return page;
    },
    async createPage(_, data) {
      const { name, slug, page_template_id, page_palette_id } = data;
      const page = await api.createPage(
        name,
        slug,
        page_template_id,
        page_palette_id
      );
      return page;
    },
    async updatePage({ commit }, { id, data }) {
      const page = await api.updatePage(id, data);
      commit(types.SET_PAGE, page);
      return page;
    },
    async duplicatePage(_, id) {
      return await api.duplicatePage(id);
    },
    async deletePage(_, id) {
      return await api.deletePage(id);
    },
    async setAsHomePage(_, id) {
      return await api.setAsHomePage(id);
    },
    async removeAsHomePage(_, pageData) {
      const page = await api.updatePage(pageData.id, {
        ...pageData,
        is_home_page: false,
        category: pageData.category?.id,
      });
      return page;
    },
    async unpublishPage(_, id) {
      const page = await api.unpublishPage(id);
      return page;
    },
    async publishPage(_, id) {
      const page = await api.publishPage(id);
      return page;
    },
    async getPageTemplates() {
      return await api.getPageTemplates();
    },
    async getPageTemplateCategories() {
      return await api.getPageTemplateCategories();
    },
  },
  mutations: {
    [types.SET_PAGE](state: State, page: PageResponse) {
      state.page = page;
    },
  },
};

export default pageModule;
